import React from 'react';
import { VerifyPasswordEntry } from '../verifyPassword/VerifyPasswordEntry';
import { UpdateAuthenticator } from './UpdateAuthenticator';
import { useSteps } from '@workday/upc-common';

export function ChangeAuthenticatorSteps({ onCloseModal }) {
    const { next, previous, currentStep } = useSteps();

    return currentStep === 0 ? (
        <VerifyPasswordEntry onClose={onCloseModal} onNext={next} operation='change-authenticator' />
    ) : currentStep === 1 ? (
        <UpdateAuthenticator onCloseModal={onCloseModal} onPrevious={previous} />
    ) : null;
}
